import request from '@/utils/request'


// 查询菜单列表
export function listConfig(para) {
  return request({
    url: '/system/config/list',
    method: 'post',
    data: para
  })
}
export function addConfig(para) {
    return request({
      url: '/system/config/add',
      method: 'post',
      data: para
    })
}
export function updateConfig(para) {
    return request({
      url: '/system/config/edit',
      method: 'post',
      data: para
    })
}

export function getConfig(configId) {
    return request({
      url: '/system/config/detail/'+configId,
      method: 'get',
    
    })
}
export function delConfig(configId) {
    return request({
      url: '/system/config/remove/'+configId,
      method: 'get',
    })
}


